import React, { FC } from 'react'

import Heading from 'uiKit/texts/Heading'
import { SearchIcon } from 'uiKit/icons/Icons'
import withStyles from '@material-ui/core/styles/withStyles'
import { connect } from 'react-redux'
import * as Styles from 'tabs/nlp/components/searchField/styles'
import { CrossIcon } from 'uiKit/icons/CrossIcon'

type DatasetRelationshipsHeaderProps = {
  count?: number
  search: string
  classes: any
  onChange: (value: string) => void
}

const RelationshipsHeader: FC<DatasetRelationshipsHeaderProps> = ({ count = 0, search, classes, children, onChange }) => {
  return (
    <>
      <Heading>Relationships {count > 0 && <small>({count})</small>}</Heading>

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
        }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className={classes.inputHolder}>
            <input
              className={classes.input}
              placeholder="Search.."
              value={search}
              onChange={event => onChange(event.target.value)}
            />
            {!search && <SearchIcon width="20" height="20" color="var(--color-mischka-grey)" />}
            {search && (
              <Styles.IconWrap onClick={() => onChange('')}>
                <CrossIcon size="18" color="inherit" />
              </Styles.IconWrap>
            )}
          </div>
        </div>

        {children}
      </div>
    </>
  )
}

const styles: Record<any, any> = () => ({
  inputHolder: {
    border: '1px solid var(--color-ghost-grey)',
    width: 'max-content',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'var(--color-white)',
    marginRight: 10,
    padding: 10,
    maxHeight: 45,
    minWidth: 340,
  },
  input: {
    width: '100%',
    padding: '10px',
    border: 'none',
    outline: 'none',
    borderRadius: '5px',
    fontSize: '14px',
    lineHeight: '19px',
    backgroundColor: 'var(--color-white)',
  },
  submitButton: {
    backgroundColor: 'var(--color-button-primary)',
    boxShadow: '0px 3px 9px rgba(19, 69, 186, 0.206267)',
    borderRadius: 10,
    height: 45,
    outline: 'none',
    '&:hover': {
      backgroundColor: 'var(--color-button-primary)',
    },
  },
  submitButtonText: {
    color: 'var(--color-text-on-primary)',
    margin: 0,
    fontWeight: 500,
    fontSize: 16,
    textTransform: 'none',
    fontFamily: 'Lato, sans-serif',
  },
  paper: {
    padding: '30px 50px 24px',
  },
  tableCellData: {
    margin: 'auto 0',
  },
  userImageContainer: {
    height: 40,
    flex: '0 0 40px',
    position: 'relative',
    marginRight: 8,
  },
  userImage: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'top',
    borderRadius: '50%',
    overflow: 'hidden',
  },
  userStatus: {
    position: 'absolute',
    boxSizing: 'border-box',
    width: 10,
    height: 10,
    border: '2px solid var(--color-white)',
    borderRadius: '50%',
    bottom: 0,
    right: 0,
  },
})

// Apply styles
const StyledTablesHeader = withStyles(styles, { withTheme: true })(RelationshipsHeader)

// Connect to Redux
export const DatasetRelationshipsHeader = connect(null)(StyledTablesHeader)
